import { Component, Injector, Input, OnChanges, OnInit } from '@angular/core';
import { ComponentBase } from '@abstracts/component-base';
import { ChargingPowerProfile } from '@models/chargingPowerProfile';

@Component({
  selector: 'charging-power-profile-badge',
  templateUrl: './charging-power-profile-badge.component.html',
  styleUrls: ['./charging-power-profile-badge.component.scss'],
})
export class ChargingPowerProfileBadge implements OnInit, OnChanges {

  public className: string;

  public caption: string
  public tooltip: string
  @Input() profile: ChargingPowerProfile
  @Input() isCaptioned: boolean = true
  @Input() isColored: boolean = true
  @Input() isTooltipped: boolean = true

  constructor() {}

  ngOnInit(): void {
    this.setCaption()
  }

  ngOnChanges(): void {
    this.setCaption()
  }

  setCaption() {
    switch (this.profile.key) {

      case 'now':
        this.caption = 'mit Standard'
        this.tooltip = 'Höchste verfügbare Ladeleistung. Drosselt die Ladeleistung nur bei hoher Auslastung.'
        break

      case 'minpv':
        this.caption = 'mit Netz und Sonne'
        this.tooltip = 'Garantiert 4 kW Ladeleistung aus Netzenergie. Erhöht die Ladeleistung mit verfügbarer Sonnenenergie.'
        break

      case 'pv':
        this.caption = 'nur mit Sonne'
        this.tooltip = 'Ohne Ladeleistung aus Netzenergie. Ladeleistung ist abhängig von verfügbarer Sonnenenergie.'
        break

      default: this.caption = 'undefiniert'; break
    }
  }
}
